<template>
  <div>
    <v-toolbar class="white people-navbar" height="80px" flat fixed>
      <v-toolbar-title>
        <div v-bind:class="[viewingProfile ? 'active-logo' : '', 'people-logo']" @click="handleClick()"><v-icon v-if="viewingProfile" class="back-icon" medium>keyboard_backspace</v-icon>People</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-text-field
        hide-details
        append-icon="search"
        single-line
        placeholder="Search by name or email"
        @input="onInput($event)"
      ></v-text-field>
      <v-icon class="view-sheet-icon" medium>note</v-icon>
    </v-toolbar>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
    };
  },
  methods: {
    onInput(input){
      this.$emit("updatedSearchTerm", input)
    },
    handleClick(){
      if(this.viewingProfile){
        this.$emit("backToMainPeoplePage");
      }
    }
  },
  props: ['viewingProfile']
};
</script>
<style scoped>
.people-navbar{
  position: fixed;
  margin: -12px 0px 0px -12px;
  width: calc(100% - 80px);
  max-width: calc(100% - 80px);
  z-index: 8;
}
.space{
  width: 78px;
}
.view-sheet-icon{
  margin-top: 10px;
  margin-left: 30px;
}
.back-icon{
  margin-right: 15px;
}
.people-logo{
  text-transform: uppercase;
  color: rgb(100, 100, 100);
  font-weight: bold;
}
.active-logo{
  margin-left: 80px;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/People/PeopleNavigation.vue